import { createFileRoute } from '@tanstack/react-router'

import { NoProjectPage } from '@/components/Customer/NoProjectPage'
import { openOneProject } from '@/utils/customer-shadow'

export const Route = createFileRoute(
  '/internal/customer-view/$userId/project/',
)({
  // Opens one of the customer's projects. Only a customer with none gets as
  // far as the component.
  beforeLoad: openOneProject,
  component: NoProjectPage,
})
